import { useRef, useCallback, useEffect } from 'react';
import { useUnmount } from '@betgames/bg-tools';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

interface IHistory {
    location: ReturnType<typeof useLocation>;
    navigate: ReturnType<typeof useNavigate>;
    params: ReturnType<typeof useParams>;
    listen(callback: ICallback<string>): () => void;
}

export const useHistory = (): IHistory => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const listenerRef = useRef<ICallback<string>>();
    const listen = useCallback((callback: ICallback<string>): (() => void) => {
        listenerRef.current = callback;

        return () => {
            listenerRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (listenerRef.current) {
            listenerRef.current(location.pathname);
        }
    }, [location]);

    useUnmount(() => {
        listenerRef.current = null;
    });

    return {
        listen,
        location,
        navigate,
        params,
    };
};
